import {FC} from 'react'

import {Button} from '@/components/common/content/Button'
import {ButtonVariant} from '@/components/common/content/ButtonTypes'
import {Link} from '@/i18n'
import {CONTAINER_PADDING, SECTION_PADDING_MOBILE} from '@/theme/sizing'
import {theme} from '@/theme/theme'
import {MOBILE_SCREENSIZE} from '@/utils/styles/breakpoints'

import {Text, TextVariant} from '../content/Text'
import {ArrowIcon} from '../icons/ArrowIcon'

type BrandGrowthBannerProps = {
  title: string
  buttonLinkHref: string
  buttonLinkText: string
  onClick?: () => void
}

export const BrandGrowthBanner: FC<React.PropsWithChildren<BrandGrowthBannerProps>> = ({
  title,
  buttonLinkHref,
  buttonLinkText,
  onClick,
}) => {
  return (
    <>
      <div className="content">
        <Text variant={TextVariant.h2} align="center">
          {title}
        </Text>
        <div className="button-wrapper">
          <Link href={buttonLinkHref} onClick={onClick}>
            <Button
              variant={ButtonVariant.primary}
              type="button"
              icon={<ArrowIcon color={theme.palette.text.white} />}
              isIconAnimated
            >
              {buttonLinkText}
            </Button>
          </Link>
        </div>
      </div>
      <div className="image-wrapper">
        <picture>
          <source
            srcSet="/images/flowers-mobile.svg"
            media={MOBILE_SCREENSIZE}
            width={310}
            height={140}
          />
          <img
            src="/images/flowers.svg"
            alt="Flowers"
            width={1060}
            height={230}
            loading="lazy"
            decoding="async"
            className="image"
          />
        </picture>
      </div>

      <style jsx>{`
        .content {
          position: relative;
          max-width: 700px;
          margin: 0 auto;
          z-index: 1;
        }

        .button-wrapper {
          margin-top: ${theme.spacing[5]};
          text-align: center;
        }

        .image-wrapper {
          position: absolute;
          width: 100%;
          bottom: 0;
          left: 0;
          padding: 0 ${CONTAINER_PADDING};
        }

        .image {
          display: block;
          margin: 0 auto;
          width: 100%;
          height: auto;
          max-height: 240px;
        }

        @media ${MOBILE_SCREENSIZE} {
          .button-wrapper {
            margin-top: ${theme.spacing[4]};
          }

          .image-wrapper {
            position: relative;
            padding: 0;
            margin-top: ${theme.spacing[4]};
            margin-bottom: -${SECTION_PADDING_MOBILE};
          }

          .image {
            max-height: 120px;
          }
        }
      `}</style>
    </>
  )
}
